import React, { useState } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { Container, Icon } from '@lightful/ray';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Location } from 'history';
import { useCurrentContext } from '../contexts/CurrentContext';
import { show as showIntercom } from '../utils/intercom';
import LightfulLogoWhite from '../images/lightful_logo_white.svg';
import LightfulLogoPurple from '../images/lightful_logo_purple.svg';
import './AppNav.scss';

const activeStyle = { backgroundColor: 'rgba(255, 255, 255, 0.1)' };

export const AppNav: React.FunctionComponent<{ location: Location }> = props => {
  const [isOpen, setIsOpen] = useState(false);
  const { customer } = useCurrentContext();
  const { t } = useTranslation();
  const {
    location: { pathname },
  } = props;

  if (pathname.includes('bridge-signup') || pathname.includes('bridge-success')) return null;

  if (pathname.includes('payment') || !customer) {
    return (
      <Container>
        <img className="mt-2 logo-no-nav" src={LightfulLogoPurple} width={100} alt="Lightful" />
      </Container>
    );
  }

  document.body.classList.add('has-nav');

  return (
    <nav className={classNames('app-nav', { 'app-nav--open': isOpen })}>
      <div className="">
        <div className="d-flex justify-content-between align-items-center">
          <NavLink className="d-flex m-1 m-md-2 align-items-center font-weight-bold text-white" to="/">
            <img src={LightfulLogoWhite} width={100} alt="Lightful" />
          </NavLink>
          <Icon
            className="d-md-none m-1"
            isActive
            name={isOpen ? 'close' : 'burgerMenu'}
            size={24}
            theme="white"
            onClick={() => setIsOpen(!isOpen)}
          />
        </div>
        <div className={classNames('app-nav-menu', { 'app-nav-menu--open': isOpen })}>
          <NavLink
            activeStyle={activeStyle}
            activeClassName="app-nav-item--active"
            className="app-nav-item text-white px-2 py-1 no-underline text-sm font-weight-normal"
            exact
            to="/"
            onClick={() => setIsOpen(false)}
          >
            <Icon className="mr-1" name="user" size={24} /> {t('app:navDashboardLink')}
          </NavLink>
          <NavLink
            activeStyle={activeStyle}
            activeClassName="app-nav-item--active"
            className="app-nav-item text-white px-2 py-1 no-underline text-sm font-weight-normal"
            to="/plans"
            onClick={() => setIsOpen(false)}
          >
            <Icon className="mr-1" name="plan" size={24} /> {t('app:navPlansLink')}
          </NavLink>
          <NavLink
            activeStyle={activeStyle}
            activeClassName="app-nav-item--active"
            className="app-nav-item text-white px-2 py-1 no-underline text-sm font-weight-normal"
            to="/billing"
            onClick={() => setIsOpen(false)}
          >
            <Icon className="mr-1" name="billing" size={24} />
            {t('app:navBillingLink')}
          </NavLink>
          <span
            className="app-nav-item text-white px-2 py-1 no-underline text-sm cursor-pointer live-chat"
            onClick={() => {
              setIsOpen(false);
              showIntercom();
            }}
          >
            <Icon className="mr-1" name="chat" size={24} />
            {t('app:navChatLink')}
          </span>
          <div className="mx-2 my-1 border-top" />
          <a
            className="px-2 py-1 app-nav-item text-white d-flex align-items-center no-underline text-sm"
            href={process.env.REACT_APP_PLATFORM_URI}
          >
            <Icon className="mr-1 flex-shrink-0" name="dashboard" size={24} /> {t('app:navPlatformLink')}
          </a>
        </div>
      </div>
    </nav>
  );
};

export default withRouter(AppNav);
